import ApiService from '@/services/core/api.service'

const AreaService = {
  async get (query) {
    return ApiService.get(`admin/areas?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/areas', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/areas/${payload.id}`, payload)
  }
}

export default AreaService
